import BaseApi from "@/core/HttpResources/BaseApi";
import AnnoucementPublish from "@/models/annoucement/annoucementPublish.Model";
import UrlForm from '@/models/urlForm.model';
export default class AnnoucementService {
  baseApiPublish = new BaseApi("ResearchCenters");

  async getRocord(name: string): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "SearchByName",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

  async getActiveForm(): Promise<UrlForm> {
    let urlFormApi = new BaseApi("UrlForm");
    return new Promise<any>((resolve, reject) =>
      urlFormApi.request(
        "GET",
        "GetActiveForm",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }

}